/* eslint-disable import/no-default-export */
import {PaymentRequestController} from './PaymentRequestController';
import {AppDataWithReportError} from '../../types/types';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';

export const controller = (controllerParams: ControllerParams): IWidgetController => {
  let controllerClass: PaymentRequestController | undefined;

  return {
    async pageReady() {
      try {
        controllerClass = new PaymentRequestController(controllerParams);

        await controllerClass.init();
        controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controllerClass!.load());
      } catch (error) {
        /* istanbul ignore next */
        console.error(error);
        /* istanbul ignore next */
        controllerParams.controllerConfig.setProps({generalError: true});
        /* istanbul ignore next */
        (controllerParams.appData as AppDataWithReportError)?.reportError?.(error as Error);
      }
    },
  };
};

export default controller;
